import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import LuontiMob from './LuontiMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';




let stopupdates = function () {};


function Luonti(p)
{
	React.useEffect( () => { if ( window.RECENTLOAD )  window.drawLuonti() });
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;

	if (! window.KAIKKILUONTIKUVATLADATTU )
	{
		function loopy()
		{
				if (! window.KAIKKILUONTIKUVATLADATTU )
				{
					setTimeout(loopy, 500);
				}
				else
				{
					let empty = [];
					stopupdates(empty);
				}
				pupdate((window.allmedia.luonti.length) + " images out of " + window.allmedia.luontis);
				pupdateLp(100 * (window.allmedia.luonti.length/window.allmedia.luontis));
		}
		setTimeout(loopy, 1000);
		return(	<ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />{nomoreload}
				</div>
			</div></ThemeProvider>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<LuontiMob />);
		}
		else
		{


			return (<div style={{color: "#000000", fontSize: "125%"}}>
			<div key="luontiosioekaa" className="kuvallinenvasen">
				<div>
					<h1>{window.LUONTITEKSTIT.ekaosio}</h1>
					<div key="gapihmomia" className="otsikkogap"></div>
					{window.LUONTITEKSTIT.ekaosioekar}
					<div key="gapihmomib" className="paragap"></div>
					{window.LUONTITEKSTIT.ekaosiotokar}
				</div>
				<div></div><div></div>
			</div>
			<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
			<div key="gapihmomic" className="osiogap"></div>
			<div key="luontiosiotokab" className="kuvallinenoikeakapea">
				<div style={{fontSize:"56.25%"}}>
					<img height="400vh" src={window.LUONTITEKSTIT.tokaosiokuva} /><br/>
					{window.LUONTITEKSTIT.tokaosiokuvateksti}
				</div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
					<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
						<div style={{fontFamily: "montsB"}}>{window.LUONTITEKSTIT.tokaosioekar}</div>
						<div key="gapihmomid" className="osiogap"></div>
						<div>{window.LUONTITEKSTIT.tokaosiotokar}</div>
						<div key="gapihmomie" className="paragap"></div>
						<div>{window.LUONTITEKSTIT.tokaosiokolmasr}</div>
						<div key="gapihmomif" className="paragap"></div>
						<div>{window.LUONTITEKSTIT.tokaosioneljasr}</div>
					</div>
				</div>
			</div>
			<div key="gapihmomig" className="osiogap"></div>
			<div key="luontiosioekac" className="kuvallinenvasen">
				<div>
					<h1>{window.LUONTITEKSTIT.kolmasosio}</h1>
					<div key="gapihmomih" className="otsikkogap"></div>
					{window.LUONTITEKSTIT.kolmasosioekar}
					<div key="gapihmomii" className="paragap"></div>
					{window.LUONTITEKSTIT.kolmasosiotokar}
				</div>
				<div><img height="250vh" src={window.LUONTITEKSTIT.kolmasosiokuva} /></div>
			</div>
			<div key="gapihmomij" className="osiogap"></div>
			<div key="gapihmomik" className="osiogap"></div>
			<div className="keskitetty">
				<h3>{window.LUONTITEKSTIT.neljasosio}</h3>
			</div>
			<div key="gapihmomil" className="osiogap"></div>
			<div key="luontineljasosio" className="kuvallinenvasenmargi">
				<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
					<div style={{display: "inline-block", verticalAlign: "baseline", lineHeight:"1"}}>
						{window.LUONTITEKSTIT.neljasosioekar}
						<div key="gapihmomim" className="paragap"></div>
						{window.LUONTITEKSTIT.neljasosiotokar}
					</div>
				</div>
				<div>
					<img height="300vh" src={window.LUONTITEKSTIT.neljasosiokuva} />
				</div>

			</div>
			<div key="gapihmomin" className="osiogap"></div>
			<div className="vasen" style={{fontSize:"56.25%"}}>
					{window.LUONTITEKSTIT.sivunalateksti}
			</div>
			<div className="vasen" style={{fontSize:"56.25%"}}>
					{window.LUONTITEKSTIT.sivunalatekstivideo}
			</div>
			<div className="seuraavasivu">
				<div className="seuraavasivuotsikko" >
					<Link to="../kasittely" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKasittely}>
						<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>KÄSITTELY</span>
					</Link>
				</div>
				<div style={{transform: "scale(0.75)"}}>
					<Link to="../kasittely" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToKasittely}>
						<ArrowRight  stroke="#000000"/>
					</Link>
				</div>
			</div>

			</div>);
		}
	}
}
function moveToKasittely()
{
	window.SETKASITTELY();
	window.drawKasittely();
}


export default Luonti;
